var MediaPathMixin = {

    methods: {
        getMediaPath: function (url) {
            return config.MEDIA_DIRECTORY + url.replace(/\/media\//g, "");
        },
    }
}